<template>
    <create-user :edit-user="true" tittle-form="Editar Usuario" :id-user='userId' />
</template>
<script>
    import CreateUser from '../../components/CreateUser'
    export default {
        /**Componente del modulo usuarios usado cuando se edita un usuario.
         * Es componente padre del componente CreateUser el cual contiene el formulario
         * para ingresar los datos del usuario */
        name: 'EditUser',
        title: 'Editar Usuario | Infoguia',
        props: {
            userId: {
                required: true,
            },
        },
        components: {
            CreateUser,
        },
    }
</script>